import { createContext, useState, useContext, ReactNode } from "react";
import { PriorityGroups } from "../api/models";


interface Props {
    children?: ReactNode;
}

interface userNameData {
    user?: string;
    pushUser?: Function;
    removeUser?: Function;
    token?: string;
    pushToken?: Function;
    removeToken?: Function;
    priorityGroups?: PriorityGroups | undefined;
    pushPriorityGroups?: Function;
    removePriorityGroups?: Function;
    userName?: string;
    pushUserName?: Function;
    removeUserName?: Function;
    seccion?: string;
    pushSeccion?: Function;
    removeSeccion?: Function;
    scope?: string;
    pushScope?: Function;
    removeScope?: Function;
    favQuestions?: string[];
    pushFavQuestions?: Function;
    pushReceivedFavQuestions?: Function;
    removeFavQuestions?: Function;
    historyQuestions?: string[];
    pushReceivedHistQuestions?: Function;
    removeHistQuestions?: Function;
    removeOneFavQuestion?: Function;
    clickedFavQuestion?: [signal: boolean, question: string];
    isFavQuestionClicked?: Function;
    isHistQuestionClicked?: Function;
    acceso?: string;
    pindi?: string;
    pushPindi?: Function;
    removePindi?: Function;
    salesMediaName?: string;
    pushSalesMediaName?: Function;
    removeSalesMediaName?: Function;
    userDepartment?: string;
    pushUserDepartment?: Function;
    removeUserDepartment?: Function;
    origin?: string;
    pushOrigin?: Function;
    removeOrigin?: Function;
    loginMethod?: string;
    pushLoginMethod?: Function;
    removeLoginMethod?: Function;
}

export const useUserData = () => {
    const [historyQuestions, setHistoryQuestions] = useState<string[]>([]);

    const pushReceivedHistQuestions = (questions: string[]) => {
        console.log("Actualizando historyQuestions con:", questions);
        setHistoryQuestions(questions);
    };

    return {
        historyQuestions,
        pushReceivedHistQuestions,
    };
};

export const UserContext = createContext<userNameData>({});

export const useUser = () => {
    const userData = useContext(UserContext);
    return userData;
};

export const UserProvider = ({ children }: Props) => {
    const [user, setUser] = useState<string>("");
    const [token, setToken] = useState<string>("");
    const [priorityGroups, setPriorityGroups] = useState<PriorityGroups | undefined>(undefined);
    const [userName, setUserName] = useState<string>("");
    const [seccion, setSeccion] = useState<string>("");
    const [scope, setScope] = useState<string>("");
    const [acceso, setAcceso] = useState<string>("");
    const [favQuestions, setFavQuestions] = useState<string[]>([]);
    const [historyQuestions, setHistoryQuestions] = useState<string[]>([]); // Añadido
    const [clickedFavQuestion, setClickedFavQuestion] = useState<[signal: boolean, question: string]>([false, ""]);
    const [pindi, setPindi] = useState<string>("");
    const [salesMediaName, setSalesMediaName] = useState<string>("");
    const [userDepartment, setUserDepartment] = useState<string>("");
    const [origin, setOrigin] = useState<string>("");
    const [loginMethod, setLoginMethod] = useState<string>("");

    const pushLoginMethod = (method: string) => {
        setLoginMethod(method);
    };
    const removeLoginMethod = () => {
        setLoginMethod("");
    };

    // Manejo del historial
    const pushReceivedHistQuestions = (questions: string[]) => {
        console.log("Actualizando historyQuestions con:", questions);
        setHistoryQuestions(questions);
    };

    const removeHistQuestions = () => {
        console.log("Eliminando todas las preguntas del historial");
        setHistoryQuestions([]);
    };

    const pushUser = (dataUser: string) => {
        setUser(dataUser);
    };

    const removeUser = () => {
        setUser("");
    };

    const pushToken = (dataToken: string) => {
        setToken(dataToken);
    };

    const removeToken = () => {
        setToken("");
    };

    const pushPriorityGroups = (dataPriorityGroups: PriorityGroups | undefined) => {
        setPriorityGroups(dataPriorityGroups);
    };

    const removePriorityGroups = () => {
        setPriorityGroups(undefined);
    };

    const pushUserName = (dataName: string) => {
        setUserName(dataName);
    };

    const removeUserName = () => {
        setUserName("");
    };

    const pushSeccion = (dataSeccion: string) => {
        setSeccion(dataSeccion);
    };

    const removeSeccion = () => {
        setSeccion("");
    };

    const pushScope = (dataScope: string) => {
        setScope(dataScope);
    };
    const removeScope = () => {
        setScope("");
    };

    const pushUserDepartment = (dataUserDepartment: string) => {
        setUserDepartment(dataUserDepartment);
    }
    const removeUserDepartment = () => {
        setUserDepartment("");
    }

    const pushFavQuestions = (dataFav: string) => {
        setFavQuestions([...favQuestions, dataFav]);
    };

    const pushReceivedFavQuestions = (favQuestions: string[]) => {
        setFavQuestions(favQuestions);
    };
    const removeFavQuestions = () => {
        setFavQuestions([]);
    };

    const removeOneFavQuestion = (indexQuestion: number) => {
        let arrayQuestions = Array.from(favQuestions);
        arrayQuestions.splice(indexQuestion, 1);
        setFavQuestions(arrayQuestions);
    };

    const isFavQuestionClicked = (signal: boolean, question: string) => {
        setClickedFavQuestion([signal, question]);
    };
    const isHistQuestionClicked = (signal: boolean, question: string) => {
        setClickedFavQuestion([signal, question]);
    };
    const pushAcceso = (dataAcceso: string) => {
        setAcceso(dataAcceso);
    };
    const removeAcceso = () => {
        setAcceso("");
    };
    const pushPindi = (dataPindi: string) => {
        setPindi(dataPindi);
    };
    const removePindi = () => {
        setPindi("");
    };
    const pushSalesMediaName = (dataSalesMediaName: string) => {
        setSalesMediaName(dataSalesMediaName);
    };
    const removeSalesMediaName = () => {
        setSalesMediaName("");
    };
   
    const pushOrigin = (dataOrigin: string) => {
        setOrigin(dataOrigin);
    };
    const removeOrigin = () => {
        setOrigin("");
    };

    const values = {
        user,
        pushUser,
        removeUser,
        token,
        pushToken,
        removeToken,
        priorityGroups,
        pushPriorityGroups,
        userName,
        pushUserName,
        removeUserName,
        seccion,
        pushSeccion,
        removeSeccion,
        scope,
        pushScope,
        removeScope,
        favQuestions,
        pushFavQuestions,
        pushReceivedFavQuestions,
        removeFavQuestions,
        removeOneFavQuestion,
        historyQuestions, // Exponer el historial
        pushReceivedHistQuestions, // Función para añadir preguntas al historial
        removeHistQuestions, // Función para limpiar el historial
        clickedFavQuestion,
        isFavQuestionClicked,
        isHistQuestionClicked,
        pushAcceso,
        removeAcceso,
        acceso,
        pindi,
        pushPindi,
        removePindi,
        salesMediaName,
        pushSalesMediaName,
        removeSalesMediaName,
        userDepartment,
        pushUserDepartment,
        removeUserDepartment,
        origin,
        pushOrigin,
        removeOrigin,
        loginMethod,
        pushLoginMethod,
        removeLoginMethod
    };

    return <UserContext.Provider value={values}>{children}</UserContext.Provider>;
};
